import { render, staticRenderFns } from "./TournamentPanel.vue?vue&type=template&id=4a9ee956&scoped=true&"
import script from "./TournamentPanel.vue?vue&type=script&lang=js&"
export * from "./TournamentPanel.vue?vue&type=script&lang=js&"
import style0 from "./TournamentPanel.vue?vue&type=style&index=0&id=4a9ee956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ee956",
  null
  
)

export default component.exports